module.exports = __webpack_public_path__ + "static/media/download.a3579d4f.svg";